<template>
  <div class="form-group mb-0" :class="{'d-flex justify-content-center items-center': isInline}">
    <label :for="name" class="col-form-label font-size-lg" :class="{
      'col-form-label-sm': size.toString() === 'sm',
      'col-form-label-lg': size.toString() === 'lg',
    }">{{ title }}
      <span class="text-danger" v-if="required">*</span>
    </label>

    <div class="" :style="[isInline ? {flexGrow: 1} : {}]">
      <select class="form-control select2 invoice-item-select" :class="showError === true && state === false ? 'border-box-error' : ''"
              v-model="modelProxy"
              :multiple="multiple"
              @change="onSelect"
              :id="name"
      >
        <option :value="null">{{ $t('general.select_option') }}</option>
        <template v-for="value in values">
          <option :value="value.id">{{ value.name}}</option>
        </template>
      </select>
    </div>
    <info-tooltip
        :helper-text="helperText"
        v-if="helperText"
    ></info-tooltip>
    <p class="text-danger pt-1 px-3 block" v-if="error">{{ error }}</p>
  </div>

</template>

<script>

import 'vue-multiselect/dist/vue-multiselect.min.css'
import InfoTooltip from "@/assets/components/widget/InfoTooltip";

export default {
  name: "MultipleSelectInput",
  props: {
    title: {},
    name: {},
    values: {},
    error: {},
    model: {},
    required: {
      required: false,
      default: false,
    },
    label: {
      required: false,
      default: "name"
    },
    searchable: {
      required: false,
      default: false
    },
    trackBy: {
      required: false,
      default: "id"
    },
    disabled: {
      required: false,
      default: false
    },
    multiple: {
      required: false,
      default: true,
    },
    state: {
      required: false,
      default: null,
    },
    showError: {
      required: false,
      default: false,
    },
    max: {
      required: false,
      default: 10,
    },
    helperText: {
      default: null,
      required: false,
      type: String,
    },
    size: {
      default: 'sm',
      validator: function validator(l) {
        return ['xs', 'sm', 'md', 'lg'].indexOf(l) > -1;
      }
    },
    isInline: {
      required: false,
      default:true,
    },
  },
  components: {
    InfoTooltip
  },
  computed: {
    modelProxy: {
      get() {
        return this.model
      },
      set(value) {
        this.$emit('update:model', value)
      }
    }
  },
  methods: {
    onSelect($event) {
      this.$emit('onSelect', $event.target.value)
    }
  }
}
</script>

<style type="text/css">
.multiselect{
  height: 40px !important;
  padding: 0 !important;
}
.multiselect__tags{
  /*padding-top: 0 !important;*/
  background: transparent !important;
}
.multiselect__placeholder{
  margin-bottom: 0 !important;
}

.multiselect {
  border: none !important;
}

.form-control .multiselect__tags {
  border-radius: 0.42rem !important;
}

.border-box-error {
  border: 1px solid #ff5b5c !important;
}

/*.multiselect--disabled {*/
/*  .multiselect__tags{*/
/*    background: #ecf0f3 !important;*/
/*    opacity: 1 !important;*/
/*  }*/
/*}*/

/*.multiselect--disabled > .multiselect__tags {*/
/*  background: #ecf0f3 !important;*/
/*}*/
</style>
